import {DataStatus} from 'platform/components';
import {Grid, GridItem} from 'platform/foundation';

import {useGetVehicleV2Query} from '@dms/api/sales';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {CommentsWidget, VehicleServiceIntervalsCard} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface VehicleServiceIntervalsProps extends RequiredTestIdProps {
  vehicleId: string;
}

export function VehicleServiceIntervals(props: VehicleServiceIntervalsProps) {
  const vehicleV2Query = useGetVehicleV2Query({vehicleId: props.vehicleId});

  return (
    <DataStatus isLoading={vehicleV2Query.isLoading} isError={vehicleV2Query.isError}>
      <Grid columns={2}>
        <GridItem>
          <VehicleServiceIntervalsCard
            vehicleData={vehicleV2Query.data}
            data-testid={suffixTestId('serviceIntervals', props)}
          />
        </GridItem>
        <GridItem>
          <CommentsWidget
            title={i18n.t('entity.vehicle.labels.vehicleComments')}
            resourceId={EntityResourceIds.vehicle}
            recordId={props.vehicleId}
          />
        </GridItem>
      </Grid>
    </DataStatus>
  );
}
